/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import fr from 'react-phone-input-2/lang/fr.json';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import { Redirect } from 'react-router-dom';
import { Form, NestedField } from 'react-form';
import swal from 'sweetalert2';
import * as ProAct from '../../Actions/ProActions';
import { inscriptionEcourrier, envoiSMSEcourrier, verifTelEcourrier, envoiEmailEcourrier, obtenirProprietaire } from '../../App_Code/API';
import { estVide, estEmailValide, estTelValide2 } from '../../App_Code/Utils';
import * as HttpStatus from '../../App_Data/HttpStatus';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import { AfficherFeedback, Texte } from '../ChampFormulaire';

const Champs = [{ Nom: 'Nom', EstTexte: true }, { Nom: 'Prenom', EstTexte: true }];

class PageEcourrierNG extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Nom: this.props.Nom,
            Prenom: this.props.Prenom,
            Tel: this.props.Tel,
            PaysTel: undefined,
            Email: this.props.Email,
            NotifSimple: this.props.Param.NotifSimple,
            NotifReco: this.props.Param.NotifRecommandee,
            Mise: this.props.Param.MiseDemeure,
            Etape: 1,
            Reinscirption: this.props.location.state ? this.props.location.state.Reinscirption : false,
            ModifContacts: 1,
        };

        this.handleChangeTypeEnvoi = this.changeTypeEnvoi.bind(this);
        this.handleChangeInfo = this.changeInfo.bind(this);
        this.handleChangeModifContacts = this.changeModifContacts.bind(this);
        this.handleEtape1 = this.Etape1.bind(this);
        this.handleEtape2 = this.Etape2.bind(this);
        this.handleEtape3 = this.Etape3.bind(this);
        this.boutonValiderE1 = React.createRef();
        this.boutonValiderE2 = React.createRef();
        this.boutonValiderE3 = React.createRef();
        this.inputs = {};
        Champs.forEach((champ) => {
            this.inputs[champ.Nom] = React.createRef();
        });
        this.Tel = React.createRef();
        this.Email = React.createRef();
    }

    componentWillUnmount() {
        if (this.unblock) this.unblock();
    }

    changeModifContacts() {
        console.log(this.state.ModifContacts)
        if (this.state.ModifContacts !== 1) {  
            this.setState({ ModifContacts: 1 });
        } else {
            this.setState({ ModifContacts: 0 });
        }
    }

    changeTypeEnvoi({ target }) {
        if (this.state.Etape !== 1) return;

        const champs = target.name;
        const saisie = target.value;
        this.setState({
            [`${champs}`]: saisie == 1,
        });
    }

    changeInfo() {
        // Recupere l'evenement
        const evt = window.event;
        const { target } = evt;
        // Recupere les infos
        const champs = target.name;
        const saisie = target.value;
        this.setState({
            [`${champs}`]: saisie,
        });
    }

    handleChange = () => {
        let affichePrompt = false;

        Champs.forEach((champ) => {
            affichePrompt = affichePrompt || !estVide(this.inputs[champ.Nom].current.defaultValue);
        });

        if (!this.unblock && affichePrompt) {
            this.unblock = this.props.history.block("Vous n'avez pas finalisé les étapes d'inscription au service courrier électronique.<br>Voulez-vous vraiment abandonner l'inscription au e-courrier ?");
        } else if (this.unblock && !affichePrompt) {
            this.unblock();
        }
    };

    Etape1() {
        let Prenom = '';
        let Nom = '';
        let formValide = true;
        this.boutonValiderE1.current.disabled = true;
        this.boutonValiderE1.current.className = 'btn btn-secondary disabled w-25';

        Champs.forEach((champ) => {
            // Vérification et enregistrement des infos
            const valeur = this.inputs[champ.Nom].current.defaultValue;
            const valide = champ.EstTexte ? !estVide(valeur) : estEmailValide(valeur);
            AfficherFeedback(this.inputs[champ.Nom], valide);
            formValide = formValide && valide;
            if (valide) {
                switch (champ.Nom) {
                case 'Nom':
                    Nom = valeur;
                    break;
                case 'Prenom':
                    Prenom = valeur;
                    break;
                default:
                    break;
                }
            }
        });

        if (!formValide) {
            this.boutonValiderE1.current.disabled = false;
            this.boutonValiderE1.current.className = 'btn btn-primary w-25';
            return;
        }

        const CourrierSimple = this.props.CourrierSimple;
        const {
            NotifSimple, Reinscirption,
        } = this.state;
        let {
            NotifReco, Mise,
        } = false;
        if (!CourrierSimple) {
            NotifReco = this.state.NotifReco;
            Mise = this.state.Mise;
        }
        if (!Reinscirption && NotifSimple == 0 && NotifReco == 0 && Mise == 0) {
            swal('Attention !', 'Aucun changement n\'ayant été demandé, il n\'y a pas lieu de valider ces choix.', 'warning');
            this.boutonValiderE1.current.disabled = false;
            this.boutonValiderE1.current.className = 'btn btn-primary w-25';
            return;
        }
        // Enregistrement des premières informations
        inscriptionEcourrier({
            Nom, Prenom, NotifSimple, NotifRecommandee: NotifReco, MiseDemeure: Mise,
        }).then((response) => {
            if (response.status === HttpStatus.OK) {
                // on bloque l'etape 1
                this.boutonValiderE1.current.hidden = true;
                Champs.forEach((champ) => {
                    this.inputs[champ.Nom].current.disabled = true;
                });
                // et on ouvre l'accees a l'etape 2
                this.boutonValiderE2.current.hidden = false;
                this.setState({ Etape: 2 });
            } else {
                const footer = response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: "Une erreur s'est produite lors de l'inscription au service courrier électronique.",
                    footer,
                });
                this.boutonValiderE1.current.disabled = false;
                this.boutonValiderE1.current.className = 'btn btn-primary w-25';
            }
        });
    }

    Etape2() {
        if (this.boutonValiderE1.current.hidden == false) return;
        // Vérification et enregistrement du tel
        const valeur = this.state.Tel;
        const valide = estTelValide2(valeur, this.state.PaysTel);
        // AfficherFeedback(this.Tel, valide);
        if (valide) {
            // Envoi du sms de validation
            envoiSMSEcourrier(valeur).then((response) => {
                if (response.status === HttpStatus.OK) {
                    this.validationTel('hidden', 3);
                } else {
                    const footer = response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                    swal({
                        type: 'error',
                        title: 'Erreur',
                        text: "Une erreur s'est produite lors de l'inscription au service courrier électronique.",
                        footer,
                    });
                }
            });
        }
    }

    async validationTel(err, nb) {
        if (nb == 0) return;
        const { value: formValues } = await swal.fire({
            title: 'Vérification du téléphone',
            html:
                `${'<label for="nom">Un code par SMS vient de vous être envoyé. Merci de le saisir ci-dessous</label>' +
                '<input id="code" class="swal2-input" type="text" placeholder="Code reçu par SMS">' +
                '<span style="color:red;visibility:'}${err}">Le code de validation saisi n'est pas correct.</span>` +
                `<br/><span>Tentatives restantes : ${nb}</span>`,
            focusConfirm: false,
            preConfirm: () => [
                document.getElementById('code').value,
            ],
        });

        if (!formValues) return;

        // Vérification du code
        verifTelEcourrier(formValues[0]).then((response) => {
            if (response.status === HttpStatus.OK) {
                // on bloque l'étape 2
                this.boutonValiderE2.current.hidden = true;
                // this.Tel.current.disabled = true
                // et on débloque l'accees a l'etape 3
                this.boutonValiderE3.current.hidden = false;
                this.setState({ Etape: 3 });
            } else {
                // sinon on re ouvre la pop up de validation
                this.validationTel('visible', nb - 1);
            }
        });
    }

    Etape3() {
        if (this.boutonValiderE2.current.hidden == false) return;
        // Sécu double clique
        this.boutonValiderE3.current.disabled = true;
        this.boutonValiderE3.current.innerHTML = '<i class="fas fa-spinner" aria-hidden="true"></i><span> En cours</span>';

        // Vérification et enregistrement de l'email
        const valeur = this.Email.current.defaultValue;
        const ModifContacts = this.state.ModifContacts;
        const Tel = this.state.Tel;
        const valide = estEmailValide(valeur);
        AfficherFeedback(this.Email, valide);
        if (valide) {
            // Envoi de l'email de validation
            envoiEmailEcourrier(valeur,ModifContacts,Tel).then((response) => {
                if (response.status === HttpStatus.OK) {
                    this.validationEmail();
                } else {
                    const footer = response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                    swal({
                        type: 'error',
                        title: 'Erreur',
                        text: "Une erreur s'est produite lors de l'envoi de l'email de confirmation.",
                        footer,
                    });
                    this.boutonValiderE3.current.disabled = false;
                    this.boutonValiderE3.current.innerHTML = 'Suivant';
                }
            });
        } else {
            this.boutonValiderE3.current.disabled = false;
            this.boutonValiderE3.current.innerHTML = 'Suivant';
        }
    }
    async validationEmail() {
        const { actions, history } = this.props;

        await swal.fire({
            title: 'Vérification de l\'email',
            html:
                '<label for="nom">Afin de valider votre adresse email, rendez-vous dans votre boîte mail et cliquez sur le bouton de confirmation contenu dans l\'email qui vient de vous être envoyé.</label>' +
                '<br/><br/><span>note : la réception peut prendre quelques minutes. En cas de non réception, merci de vérifier votre boîte des indésirables (Spams)</span>',
            focusConfirm: true,
        });

        obtenirProprietaire().then((pro) => {
            actions.proAjout(pro);
        });
        if (this.unblock) this.unblock();
        history.push('/MesInformations');
    }

    render() {
        const {
            Nom, Prenom, Tel, Email, NotifReco, NotifSimple, Mise, Etape,
        } = this.state;
        const {
            CourrierSimple, LREOk,
        } = this.props;
        return (
            <div>
                <Form onChange={this.handleChange}>
                    {formApi => (
                        <form onSubmit={formApi.submitForm}>
                            <div className="container col-xl-8">
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <h4 className="card-title text-center">Abonnement au service courrier électronique</h4>
                                        <NestedField field="Informations">
                                            <h5 className="text-muted mt-3"><span className={Etape == 1 ? 'badge badge-pill badge-primary' : 'badge badge-pill badge-secondary'}>1</span> Saisie des informations</h5>
                                            <div className="ml-5">
                                                <div className="form-group required row">
                                                    <div className="col-2 mt-2">
                                                        <label htmlFor="Nom">Nom</label>
                                                    </div>
                                                    <div className="col-6">
                                                        <Texte field="Nom" id="Nom" name="Nom" placeholder="Nom" type="text" maxLength={30} refRef={this.inputs.Nom} defaultvalue={Nom} onChange={this.handleChangeInfo} />
                                                        <div className="invalid-feedback">Veuillez renseigner votre nom</div>
                                                    </div>
                                                </div>
                                                <div className="form-group required row">
                                                    <div className="col-2 mt-2">
                                                        <label htmlFor="Prenom">Prénom</label>
                                                    </div>
                                                    <div className="col-6">
                                                        <Texte field="Prenom" id="Prenom" name="Prenom" placeholder="Prénom" type="text" maxLength={30} refRef={this.inputs.Prenom} defaultvalue={Prenom} onChange={this.handleChangeInfo} />
                                                        <div className="invalid-feedback">Veuillez renseigner votre prénom</div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-4">
                                                        <label>
                                                            <i className="fas fa-info-circle text-info" style={{ cursor: 'pointer' }} title="Les notifications simples sont les appels de fonds, les relances, les PV envoyés en courriers simples et tous les courriers divers." /> Notifications simples
                                                        </label>
                                                    </div>
                                                    <div className="col-3 custom-control custom-radio">
                                                        <input className="custom-control-input" id="NotifSimple1" name="NotifSimple" type="radio" value={1} checked={NotifSimple == 1} onChange={this.handleChangeTypeEnvoi} />
                                                        <label className="custom-control-label ml-4" htmlFor="NotifSimple1">
                                                            Electronique
                                                        </label>
                                                    </div>
                                                    <div className="col-3 custom-control custom-radio">
                                                        <input className="custom-control-input" id="NotifSimple2" name="NotifSimple" type="radio" value={0} checked={NotifSimple == 0} onChange={this.handleChangeTypeEnvoi} />
                                                        <label className="custom-control-label ml-4" htmlFor="NotifSimple2">
                                                            Postal
                                                        </label>
                                                    </div>
                                                </div>
                                                {CourrierSimple && !LREOk ? ('') :
                                                    (
                                                        <div>
                                                            <div className="form-group row">
                                                                <div className="col-4">
                                                                    <label htmlFor="Notif">
                                                                        <i className="fas fa-info-circle text-info" style={{ cursor: 'pointer' }} title="Les notifications recommandées sont les convocations aux assemblées générales et les PV envoyés en recommandés." /> Notifications recommandées
                                                                    </label>
                                                                </div>
                                                                <div className="col-3 custom-control custom-radio">
                                                                    <input className="custom-control-input" id="NotifReco1" name="NotifReco" type="radio" value={1} checked={NotifReco == 1} onChange={this.handleChangeTypeEnvoi} />
                                                                    <label className="custom-control-label ml-4" htmlFor="NotifReco1">
                                                                        Electronique
                                                                    </label>
                                                                </div>
                                                                <div className="col-3 custom-control custom-radio">
                                                                    <input className="custom-control-input" id="NotifReco2" name="NotifReco" type="radio" value={0} checked={NotifReco == 0} onChange={this.handleChangeTypeEnvoi} />
                                                                    <label className="custom-control-label ml-4" htmlFor="NotifReco2">
                                                                        Postal
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group row">
                                                                <div className="col-4">
                                                                    <label htmlFor="Notif">
                                                                        <i className="fas fa-info-circle text-info" style={{ cursor: 'pointer' }} title="Les mises en demeure concernent les relances recommandées." /> Mises en demeure
                                                                    </label>
                                                                </div>
                                                                <div className="col-3 custom-control custom-radio">
                                                                    <input className="custom-control-input" id="Mise1" name="Mise" type="radio" value={1} checked={Mise == 1} onChange={this.handleChangeTypeEnvoi} />
                                                                    <label className="custom-control-label ml-4" htmlFor="Mise1">
                                                                        Electronique
                                                                    </label>
                                                                </div>
                                                                <div className="col-3 custom-control custom-radio">
                                                                    <input className="custom-control-input" id="Mise2" name="Mise" type="radio" value={0} checked={Mise == 0} onChange={this.handleChangeTypeEnvoi} />
                                                                    <label className="custom-control-label ml-4" htmlFor="Mise2">
                                                                        Postal
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                <p className="text-muted" style={{ fontSize: '10px' }}> En choisissant &quot;Electronique&quot; vous autorisez le Groupe KEL, prestataire de votre syndic, à vous faire parvenir les emails et sms nécessaires à la réception des courriers envoyés par votre syndic. </p>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <button id="ValideE1" ref={this.boutonValiderE1} className="btn btn-primary w-25" onClick={this.handleEtape1}> Suivant </button>
                                                </div>
                                            </div>
                                            <h5 className="text-muted mt-3"><span className={Etape == 2 ? 'badge badge-pill badge-primary' : 'badge badge-pill badge-secondary'}>2</span> Validation par SMS</h5>
                                            <div className="ml-5">
                                                <div className="form-group required row">
                                                    <div className="col-2 mt-2">
                                                        <i className="fas fa-info-circle text-info" style={{ cursor: 'pointer' }} title="Le numéro de téléphone est requis, d'une part pour l'envoi de codes sécurisés pour les recommandés électroniques et, d'autre part, pour l'envoi de notifications." /> <label htmlFor="Tel">Téléphone</label>
                                                    </div>
                                                    <div className="col-6">
                                                        {/* <Texte field="Tel" id="Tel" name="Tel" placeholder="Téléphone" type="tel" refRef={this.Tel} defaultvalue={Tel} onChange={this.handleChangeInfo} />
                                                        <div className="invalid-feedback">Numéro de téléphone invalide</div> */}
                                                        <PhoneInput
                                                            country="fr"
                                                            value={Tel}
                                                            preferredCountries={['fr']}
                                                            localization={fr}
                                                            onChange={(phone, pays) => {
                                                                this.setState({ Tel: `+${phone}`, PaysTel: pays });
                                                            }}
                                                            inputExtraProps={{
                                                                name: 'Tel',
                                                                required: true,
                                                            }}
                                                            isValid={(value, country) => {
                                                                if (estTelValide2(`+${value}`, country)) {
                                                                    return true;
                                                                }
                                                                return 'Numéro de téléphone invalide';
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-2 mt-2"><label>&nbsp;</label></div>
                                                    <div className="col-10 custom-control custom-checkbox">
                                                        <input className="custom-control-input" id="cbModifContacts" name="cbModifContacts" type='checkbox' value={1} checked={this.state.ModifContacts == 1} onChange={this.handleChangeModifContacts} title='Utiliser ces coordonnées en tant que contact pour les autres notifications (news, ...)' />
                                                        <label className="custom-control-label ml-4" htmlFor="cbModifContacts" title='Utiliser ces coordonnées en tant que contact pour les autres notifications (news, ...)'>
                                                            Utiliser ces coordonnées en tant que contact pour les autres notifications (news, ...)
                                                        </label>
                                                    </div>
                                                </div>
                                                <p className="text-muted" style={{ fontSize: '10px' }}> Attention ! Pour les numéros français, n'indiquez pas le 0 initial du numéro mais seulement les 9 chiffres qui le suivent. </p>

                                                <div className="d-flex justify-content-end mt-3">
                                                    <button id="ValideE2" hidden ref={this.boutonValiderE2} className="btn btn-primary w-25" onClick={this.handleEtape2}> Suivant </button>
                                                </div>
                                            </div>
                                            <h5 className="text-muted mt-3"><span className={Etape == 3 ? 'badge badge-pill badge-primary' : 'badge badge-pill badge-secondary'}>3</span> Validation par Email</h5>
                                            <div className="ml-5">
                                                <div className="form-group required row">
                                                    <div className="col-2 mt-2">
                                                        <label htmlFor="Email">E-mail</label>
                                                    </div>
                                                    <div className="col-6">
                                                        <Texte field="Email" id="Email" name="Email" placeholder="E-mail" type="email" refRef={this.Email} defaultvalue={Email} onChange={this.handleChangeInfo} />
                                                        <div className="invalid-feedback">E-mail non valide</div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <button id="ValideE3" hidden ref={this.boutonValiderE3} className="btn btn-primary w-25" onClick={this.handleEtape3}> Suivant </button>
                                                </div>
                                            </div>
                                        </NestedField>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Form>
            </div>
        );
    }
}
PageEcourrierNG.displayName = 'PageEcourrierNG';
PageEcourrierNG.requiredProps = [
    'Actif', // Etat du service
];

function mapStateToProps({
    ProStore: {
        Pro: {
            Ecourrier: {
                Actif, Email, Tel, Nom, Prenom, Param,
            },
        },
    },
    SynStore: {
        Syn: { LREOk, CourrierSimple },
    },
}) {
    return {
        Actif, Email, Tel, Nom, Prenom, Param, LREOk, CourrierSimple,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageEcourrierNG));



// WEBPACK FOOTER //
// ./src/components/MesInfos/PageEcourrierNG.js